module.exports = __webpack_public_path__ + "static/media/downarrow.214f105d.svg";